export const getMultipleChoicePrefix = (index) => (String.fromCharCode('A'.charCodeAt(0) + index));
